import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { PapiGallection } from '@wix/da-papi-types';
import { AppState } from '../../types/store';
import { getStashFolder, getSubfolders } from '../../selectors/stash';
import { getDuperbrowseStreamVersion } from '../../selectors/studio';
import { Props } from './StashFolder';
import { fetchMoreDeviations } from '../../actions/stash';
import { copyFolderLink } from '../../actions/studio/folders';
import { STASH_FOLDER_DEVIATIONS_STREAM } from '../../../constants';
import { getIsBusy } from '../../selectors/studio/folders';

export type StateProps = Pick<
  Props,
  'folder' | 'subfolders' | 'isFetchingFolders' | 'duperbrowseStreamVersion'
>;
export type DispatchProps = Pick<Props, 'fetchMoreResults' | 'copyFolderLink'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, AppState> = state => ({
  folder: getStashFolder(state) as PapiGallection,
  subfolders: getSubfolders(state),
  isFetchingFolders: getIsBusy(state),
  duperbrowseStreamVersion: getDuperbrowseStreamVersion(state),
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = dispatch => ({
  fetchMoreResults: () => dispatch(fetchMoreDeviations(STASH_FOLDER_DEVIATIONS_STREAM.streamId)),
  copyFolderLink: (folder: PapiGallection) => dispatch(copyFolderLink(folder)),
});

export default connect(mapStateToProps, mapDispatchToProps);
